/**
 * RedCrocus Community — feed, filters, modal, submission (app proxy).
 * Expects window.RC_COMMUNITY from Liquid (proxyPrefix, loggedIn, etc.).
 */
(function () {
  'use strict';

  var cfg = window.RC_COMMUNITY || {};
  var prefix = (cfg.proxyPrefix || 'apps/redcrocus-community').replace(/^\/+|\/+$/g, '');

  /** When true, feed + modal + images read from cfg.directApiOrigin (bypasses broken Shopify app proxy for GETs). */
  var useDirectData = false;
  var blockedStorySlugs = {
    'spring-border-walk-e2e-1777055983-10': true,
  };

  function isBlockedStorySlug(slug) {
    if (!slug) return false;
    return !!blockedStorySlugs[String(slug).toLowerCase()];
  }

  function proxyAppBase() {
    return window.location.origin + '/' + prefix;
  }

  function dataApiBase() {
    if (useDirectData && cfg.directApiOrigin) {
      return String(cfg.directApiOrigin).replace(/\/+$/, '');
    }
    return proxyAppBase();
  }

  function dataFetchInit() {
    if (useDirectData && cfg.directApiOrigin) {
      return { credentials: 'omit', mode: 'cors' };
    }
    return { credentials: 'same-origin' };
  }

  function fileUrl(fileId) {
    if (!fileId) return '';
    return dataApiBase() + '/files/' + encodeURIComponent(fileId);
  }

  /**
   * All image URLs for the story detail modal: Shopify hero (if synced), API primary, then gallery_file_ids.
   * De-duplicates identical URLs (e.g. primary repeated).
   */
  function modalImageSrcs(p) {
    var seen = {};
    var out = [];
    function add(u) {
      if (!u) return;
      u = String(u);
      if (seen[u]) return;
      seen[u] = true;
      out.push(u);
    }
    if (p.shopify_primary_image_url) {
      add(p.shopify_primary_image_url);
    }
    add(fileUrl(p.primary_image_file_id));
    var g = p.gallery_file_ids;
    if (g && Array.isArray(g)) {
      g.forEach(function (id) {
        if (id) {
          add(fileUrl(String(id)));
        }
      });
    }
    return out;
  }

  function copyDefaults(k) {
    var d = {
      storyKicker: 'Garden story',
      labelPhotos: 'Photos',
      labelPhoto: 'Photo',
      copyLink: 'Copy link to share',
      copyCopied: 'Link copied',
    };
    if (cfg && cfg[k]) {
      return cfg[k];
    }
    return d[k] || '';
  }

  function storyShareUrl(slug) {
    if (!slug) return window.location.href.split('?')[0];
    var u = new URL(window.location.href);
    u.searchParams.set('story', String(slug));
    return u.toString();
  }

  function setStoryInUrl(slug) {
    var u = new URL(window.location.href);
    if (slug) {
      u.searchParams.set('story', String(slug));
    } else {
      u.searchParams.delete('story');
    }
    if (u.toString() !== window.location.href) {
      history.replaceState(null, '', u.toString());
    }
  }

  function buildChips(p) {
    var chips = [];
    if (p.post_type === 'plant_feedback') {
      chips.push(
        '<span class="community-story-view__chip community-story-view__chip--feedback">Plant feedback</span>'
      );
    }
    if (p.feedback_rating) {
      chips.push(
        '<span class="community-story-view__chip community-story-view__chip--rating" aria-label="' +
        esc(String(p.feedback_rating)) +
        ' out of 5 stars">' +
        esc(stars(p.feedback_rating)) +
        '</span>'
      );
    }
    if (p.garden_type) {
      chips.push(
        '<span class="community-story-view__chip community-story-view__chip--garden">' +
        esc(p.garden_type) +
        '</span>'
      );
    }
    if (p.season) {
      chips.push(
        '<span class="community-story-view__chip community-story-view__chip--season">' +
        esc(p.season) +
        '</span>'
      );
    }
    if (p.state) {
      chips.push(
        '<span class="community-story-view__chip community-story-view__chip--place">' + esc(p.state) + '</span>'
      );
    }
    if (p.plants_used) {
      chips.push(
        '<span class="community-story-view__chip community-story-view__chip--plants">' +
        esc(p.plants_used) +
        '</span>'
      );
    }
    if (p.feedback_product_name && p.feedback_product_name !== p.plants_used) {
      chips.push(
        '<span class="community-story-view__chip community-story-view__chip--plants">' +
        esc(p.feedback_product_name) +
        '</span>'
      );
    }
    if (!chips.length) {
      return '';
    }
    return (
      '<div class="community-story-view__chips" aria-label="Story details">' + chips.join('') + '</div>'
    );
  }

  function buildModalMediaHtml(p) {
    var imgs = modalImageSrcs(p);
    if (!imgs.length) {
      return '';
    }
    var n = imgs.length;
    var cap =
      n === 1
        ? copyDefaults('labelPhoto')
        : copyDefaults('labelPhotos') + ' <span class="community-story-view__media-count">(' + n + ')</span>';
    if (n === 1) {
      return (
        '<div class="community-story-view__media" aria-label="Photo">' +
        '<p class="community-story-view__media-caption">' +
        cap +
        '</p>' +
        '<div class="community-story-view__hero-wrap">' +
        '<img class="community-story-view__hero" src="' +
        esc(imgs[0]) +
        '" alt=""/>' +
        '</div></div>'
      );
    }
    var thumbs = imgs
      .map(function (u, i) {
        var active = i === 0 ? ' community-story-view__thumb--active' : '';
        return (
          '<button type="button" class="community-story-view__thumb js-community-thumb' +
          active +
          '" ' +
          'aria-label="Show photo ' +
          (i + 1) +
          ' of ' +
          n +
          '" ' +
          'aria-pressed="' +
          (i === 0 ? 'true' : 'false') +
          '" data-full-src="' +
          esc(u) +
          '">' +
          '<img src="' +
          esc(u) +
          '" alt="" loading="lazy" width="200" height="150" decoding="async" draggable="false"/>' +
          '</button>'
        );
      })
      .join('');
    return (
      '<div class="community-story-view__media" data-community-gallery aria-label="Photos">' +
      '<p class="community-story-view__media-caption">' +
      cap +
      ' <span class="community-story-view__media-hint">(choose a photo below)</span></p>' +
      '<div class="community-story-view__hero-wrap">' +
      '<img class="community-story-view__hero js-community-hero" src="' +
      esc(imgs[0]) +
      '" alt=""/>' +
      '</div>' +
      '<div class="community-story-view__thumbs" role="toolbar" aria-label="Photo thumbnails">' +
      thumbs +
      '</div></div>'
    );
  }

  function bindGalleryThumbs(inner) {
    var root = inner.querySelector('[data-community-gallery]');
    if (!root) {
      return;
    }
    var hero = root.querySelector('.js-community-hero');
    if (!hero) {
      return;
    }
    var thumbs = qsa('.js-community-thumb', root);
    if (!thumbs.length) {
      return;
    }
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var src = btn.getAttribute('data-full-src') || '';
        if (!src) {
          return;
        }
        hero.setAttribute('src', src);
        thumbs.forEach(function (b) {
          b.classList.remove('community-story-view__thumb--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('community-story-view__thumb--active');
        btn.setAttribute('aria-pressed', 'true');
        try {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } catch (e) {
          try {
            btn.scrollIntoView({ block: 'nearest', inline: 'center' });
          } catch (e2) {
            /* ignore */
          }
        }
      });
    });
  }

  function buildStoryViewHtml(p) {
    var media = buildModalMediaHtml(p);
    var byline = [p.customer_display_name, p.location_label].filter(Boolean).join(' · ');
    var copyLabel = copyDefaults('copyLink');
    var chips = buildChips(p);
    var tags =
      (p.tags || [])
        .map(function (t) {
          return '<span class="community-tag community-story-view__tag-pill">' + esc(t) + '</span>';
        })
        .join('');

    var story = esc(p.story_body || '').replace(/\n/g, '<br/>');
    var tips = p.tips_learned
      ? '<aside class="community-story-view__tip" role="note"><strong>Tip from this garden:</strong> ' +
        esc(p.tips_learned).replace(/\n/g, '<br/>') +
        '</aside>'
      : '';

    var commentsHtml = '';
    if (cfg.commentsEnabled && p.comments && p.comments.length) {
      commentsHtml =
        '<div class="community-story-view__comments"><h3 class="community-story-view__comments-title">Notes from gardeners</h3><ul class="community-story-view__comment-list">' +
        p.comments
          .map(function (c) {
            return (
              '<li class="community-story-view__comment"><span class="community-story-view__comment-author">' +
              esc(c.customer_display_name) +
              '</span> <span class="community-story-view__comment-body">' +
              esc(c.body) +
              '</span></li>'
            );
          })
          .join('') +
        '</ul></div>';
    }

    var textClass = media ? ' community-story-view__text--with-media' : ' community-story-view__text--text-only';
    return (
      '<div class="community-story-view">' +
      media +
      '<div class="community-story-view__text' + textClass + '">' +
      '<h2 class="community-story-view__title" id="community-modal-title">' + esc(p.title) + '</h2>' +
      '<p class="community-story-view__byline">' + esc(byline) + '</p>' +
      chips +
      (tags
        ? '<div class="community-story-view__tags" role="list">' + tags + '</div>'
        : '') +
      '<div class="community-story-view__prose wholesale-body">' + story + '</div>' +
      tips +
      commentsHtml +
      '<div class="community-story-view__actions">' +
      '<button type="button" class="community-story-view__copy js-community-copy" data-story-slug="' +
      esc(p.slug) +
      '">' + esc(copyLabel) + '</button></div>' +
      '</div></div>'
    );
  }

  function bindCopyButton(inner) {
    var b = inner.querySelector('.js-community-copy');
    if (!b) return;
    b.addEventListener('click', function () {
      var slug = b.getAttribute('data-story-slug') || '';
      var u = storyShareUrl(slug);
      if (!u || !navigator.clipboard) return;
      var msg = copyDefaults('copyCopied') || 'Copied';
      var prev = b.textContent;
      navigator.clipboard.writeText(u).then(function () {
        b.textContent = msg;
        setTimeout(function () {
          b.textContent = prev;
        }, 2000);
      });
    });
  }

  function cardImageUrl(p) {
    if (p.shopify_primary_image_url) return p.shopify_primary_image_url;
    return fileUrl(p.primary_image_file_id);
  }

  function esc(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function stars(n) {
    var count = Math.max(0, Math.min(5, parseInt(n, 10) || 0));
    var out = '';
    for (var i = 0; i < count; i++) out += '★';
    return out;
  }

  var state = {
    page: 1,
    perPage: 12,
    total: 0,
    loading: false,
    debounce: null,
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getFilters() {
    var root = qs('[data-community-root]');
    if (!root) return {};
    return {
      garden_type: (qs('[data-filter="garden_type"]', root) || {}).value || '',
      plant: (qs('[data-filter="plant"]', root) || {}).value || '',
      season: (qs('[data-filter="season"]', root) || {}).value || '',
      state: (qs('[data-filter="state"]', root) || {}).value || '',
      q: (qs('[data-filter="q"]', root) || {}).value || '',
      sort: (qs('[data-filter="sort"]', root) || {}).value || 'latest',
    };
  }

  function buildQuery(extra) {
    var f = getFilters();
    var p = Object.assign({ page: state.page, per_page: state.perPage }, f, extra || {});
    var parts = [];
    Object.keys(p).forEach(function (k) {
      var v = p[k];
      if (v === undefined || v === null || v === '') return;
      parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(v)));
    });
    return parts.length ? '?' + parts.join('&') : '';
  }

  function showSkeleton(container, n) {
    container.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var el = document.createElement('div');
      el.className = 'community-skeleton';
      el.setAttribute('aria-hidden', 'true');
      container.appendChild(el);
    }
  }

  function renderPosts(data) {
    var container = qs('[data-community-grid]');
    if (!container) return;
    var posts = ((data && data.posts) || []).filter(function (p) {
      return !isBlockedStorySlug((p && p.slug) || '');
    });
    state.total = (data && data.total) || 0;

    if (!posts.length && state.page === 1) {
      container.innerHTML =
        '<p class="community-empty" role="status">' +
        esc(cfg.copyEmpty || 'Stories will appear here once our gardeners share them.') +
        '</p>';
      var lm = qs('[data-community-loadmore]');
      if (lm) lm.hidden = true;
      return;
    }

    container.innerHTML = '';
    posts.forEach(function (p) {
      var card = document.createElement('article');
      card.className = 'community-card';
      card.setAttribute('data-slug', p.slug);

      var isFeedback = p.post_type === 'plant_feedback';
      var imgWrap = document.createElement('button');
      imgWrap.type = 'button';
      imgWrap.className = 'community-card__media';
      imgWrap.setAttribute('aria-label', (isFeedback ? 'Read feedback: ' : 'Read story: ') + (p.title || 'Community post'));
      imgWrap.addEventListener('click', function () {
        openModal(p.slug);
      });
      if (p.primary_image_file_id) {
        var im = document.createElement('img');
        im.src = cardImageUrl(p);
        im.alt = '';
        im.loading = 'lazy';
        im.width = 800;
        im.height = 600;
        imgWrap.appendChild(im);
      }

      var body = document.createElement('div');
      body.className = 'community-card__body';

      var meta = [];
      if (isFeedback) meta.push('Plant feedback');
      if (p.customer_display_name) meta.push(esc(p.customer_display_name));
      if (p.location_label || p.state) meta.push(esc((p.location_label || '') + (p.state ? (p.location_label ? ', ' : '') + p.state : '')));
      var metaEl = document.createElement('p');
      metaEl.className = 'community-card__meta';
      metaEl.textContent = meta.filter(Boolean).join(' · ');

      var h = document.createElement('h3');
      h.className = 'community-card__title';
      h.textContent = p.title || '';

      var ex = document.createElement('p');
      ex.className = 'community-card__excerpt';
      ex.textContent = p.excerpt || '';

      var tags = document.createElement('div');
      tags.className = 'community-tags';
      if (isFeedback && p.feedback_rating) {
        var rating = document.createElement('span');
        rating.className = 'community-tag community-tag--rating';
        rating.textContent = stars(p.feedback_rating);
        tags.appendChild(rating);
      }
      if (isFeedback && p.feedback_product_name) {
        var product = document.createElement('span');
        product.className = 'community-tag community-tag--feedback';
        product.textContent = p.feedback_product_name;
        tags.appendChild(product);
      }
      (p.tags || []).slice(0, 5).forEach(function (t) {
        var sp = document.createElement('span');
        sp.className = 'community-tag';
        sp.textContent = t;
        tags.appendChild(sp);
      });

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'community-card__link';
      btn.textContent = isFeedback ? (cfg.copyReadFeedback || 'Read feedback') : (cfg.copyReadMore || 'Read story');
      btn.addEventListener('click', function () {
        openModal(p.slug);
      });

      body.appendChild(metaEl);
      body.appendChild(h);
      body.appendChild(ex);
      if (tags.children.length) body.appendChild(tags);
      body.appendChild(btn);

      card.appendChild(imgWrap);
      card.appendChild(body);
      container.appendChild(card);
    });

    var lm = qs('[data-community-loadmore]');
    if (lm) {
      var loaded = state.page * state.perPage;
      lm.hidden = loaded >= state.total;
    }
  }

  function loadPosts(resetPage) {
    var container = qs('[data-community-grid]');
    if (!container) return;
    if (resetPage) state.page = 1;
    state.loading = true;
    if (state.page === 1) showSkeleton(container, 6);

    function tryLoad() {
      var url = dataApiBase() + '/posts.json' + buildQuery({ page: state.page });
      return fetch(url, dataFetchInit()).then(function (r) {
        if (
          r.status === 404 &&
          !useDirectData &&
          cfg.useDirectApiFallback &&
          cfg.directApiOrigin
        ) {
          useDirectData = true;
          return tryLoad();
        }
        if (!r.ok) throw new Error('load');
        return r.json();
      });
    }
    tryLoad()
      .then(renderPosts)
      .catch(function () {
        container.innerHTML =
          '<p class="community-msg community-msg--err" role="alert">' +
          esc(cfg.copyLoadErr || 'We couldn’t load stories. Please refresh and try again.') +
          '</p>';
      })
      .finally(function () {
        state.loading = false;
      });
  }

  function trapFocus(dialog) {
    var focusables = qsa(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dialog
    ).filter(function (el) {
      return !el.hasAttribute('disabled');
    });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
    first.focus();
  }

  function closeModal() {
    var modal = qs('[data-community-modal]');
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setStoryInUrl(null);
  }

  function openModal(slug) {
    if (isBlockedStorySlug(slug)) return;
    var modal = qs('[data-community-modal]');
    var inner = qs('[data-community-modal-inner]');
    if (!modal || !inner) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    inner.innerHTML = '<div class="community-skeleton" style="min-height:16rem" aria-hidden="true"></div>';

    function tryPost() {
      var u = dataApiBase() + '/posts/' + encodeURIComponent(slug) + '.json';
      return fetch(u, dataFetchInit()).then(function (r) {
        if (
          r.status === 404 &&
          !useDirectData &&
          cfg.useDirectApiFallback &&
          cfg.directApiOrigin
        ) {
          useDirectData = true;
          return tryPost();
        }
        if (!r.ok) throw new Error();
        return r.json();
      });
    }
    tryPost()
      .then(function (p) {
        inner.innerHTML =
          '<div class="community-modal__dialog" role="document">' +
          '<div class="community-story-view__toolbar">' +
          '<span class="community-story-view__toolbar-kicker" aria-hidden="true">' +
          esc(copyDefaults('storyKicker')) +
          '</span>' +
          '<button type="button" class="community-story-view__close" aria-label="Close">Close</button>' +
          '</div>' +
          buildStoryViewHtml(p) +
          '</div>';

        modal.setAttribute('aria-labelledby', 'community-modal-title');
        setStoryInUrl(p.slug);
        var closeBtn = qs('.community-story-view__close', inner);
        if (closeBtn) {
          closeBtn.addEventListener('click', closeModal);
        }
        bindCopyButton(inner);
        bindGalleryThumbs(inner);
        var dlg = qs('.community-modal__dialog', inner);
        if (dlg) {
          trapFocus(dlg);
        }
      })
      .catch(function () {
        inner.innerHTML =
          '<div class="community-modal__dialog community-modal__dialog--err"><p class="community-msg community-msg--err">' +
          esc(cfg.copyLoadErr || 'Could not open this story.') +
          '</p></div>';
      });

    if (!modal.__rcBackdropBound) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      modal.__rcBackdropBound = true;
    }

    if (!document.__rcCommunityEscBound) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
      document.__rcCommunityEscBound = true;
    }
  }

  function bindFilters() {
    var root = qs('[data-community-root]');
    if (!root) return;
    qsa('[data-filter]', root).forEach(function (el) {
      el.addEventListener('change', function () {
        loadPosts(true);
      });
      el.addEventListener(
        'input',
        function () {
          if (el.getAttribute('data-filter') !== 'q') return;
          clearTimeout(state.debounce);
          state.debounce = setTimeout(function () {
            loadPosts(true);
          }, 320);
        }
      );
    });
  }

  function bindLoadMore() {
    var wrap = qs('[data-community-loadmore]');
    if (!wrap) return;
    var btn = wrap.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (state.loading) return;
      state.page += 1;
      state.loading = true;
      var container = qs('[data-community-grid]');
      function fetchPage() {
        var url = dataApiBase() + '/posts.json' + buildQuery({ page: state.page });
        return fetch(url, dataFetchInit()).then(function (r) {
          if (
            r.status === 404 &&
            !useDirectData &&
            cfg.useDirectApiFallback &&
            cfg.directApiOrigin
          ) {
            useDirectData = true;
            return fetchPage();
          }
          if (!r.ok) throw new Error();
          return r.json();
        });
      }
      fetchPage()
        .then(function (data) {
          var posts = ((data && data.posts) || []).filter(function (p) {
            return !isBlockedStorySlug((p && p.slug) || '');
          });
          state.total = (data && data.total) || 0;
          posts.forEach(function (p) {
            /* duplicate card build — inline minimal */
            var isFeedback = p.post_type === 'plant_feedback';
            var card = document.createElement('article');
            card.className = 'community-card';
            var imgWrap = document.createElement('button');
            imgWrap.type = 'button';
            imgWrap.className = 'community-card__media';
            imgWrap.setAttribute('aria-label', (isFeedback ? 'Read feedback: ' : 'Read story: ') + (p.title || 'Community post'));
            imgWrap.addEventListener('click', function () {
              openModal(p.slug);
            });
            if (p.primary_image_file_id) {
              var im = document.createElement('img');
              im.src = cardImageUrl(p);
              im.alt = '';
              im.loading = 'lazy';
              imgWrap.appendChild(im);
            }
            var body = document.createElement('div');
            body.className = 'community-card__body';
            var meta = document.createElement('p');
            meta.className = 'community-card__meta';
            meta.textContent = isFeedback ? 'Plant feedback' : '';
            var h = document.createElement('h3');
            h.className = 'community-card__title';
            h.textContent = p.title || '';
            var ex = document.createElement('p');
            ex.className = 'community-card__excerpt';
            ex.textContent = p.excerpt || '';
            var tags = document.createElement('div');
            tags.className = 'community-tags';
            if (isFeedback && p.feedback_rating) {
              var rating = document.createElement('span');
              rating.className = 'community-tag community-tag--rating';
              rating.textContent = stars(p.feedback_rating);
              tags.appendChild(rating);
            }
            if (isFeedback && p.feedback_product_name) {
              var product = document.createElement('span');
              product.className = 'community-tag community-tag--feedback';
              product.textContent = p.feedback_product_name;
              tags.appendChild(product);
            }
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'community-card__link';
            b.textContent = isFeedback ? (cfg.copyReadFeedback || 'Read feedback') : (cfg.copyReadMore || 'Read story');
            b.addEventListener('click', function () {
              openModal(p.slug);
            });
            if (meta.textContent) body.appendChild(meta);
            body.appendChild(h);
            body.appendChild(ex);
            if (tags.children.length) body.appendChild(tags);
            body.appendChild(b);
            card.appendChild(imgWrap);
            card.appendChild(body);
            container.appendChild(card);
          });
          var loaded = state.page * state.perPage;
          wrap.hidden = loaded >= state.total;
        })
        .finally(function () {
          state.loading = false;
        });
    });
  }

  function bindForm() {
    var form = qs('[data-community-form]');
    if (!form) return;
    var orderCache = [];
    function selectedType() {
      var checked = form.querySelector('input[name="post_type"]:checked');
      return checked ? checked.value : 'garden_story';
    }
    function syncFeedbackFields() {
      var isFeedback = selectedType() === 'plant_feedback';
      var wrap = qs('[data-community-feedback-fields]', form);
      if (wrap) wrap.hidden = !isFeedback;
      var product = form.querySelector('input[name="feedback_product_name"]');
      var rating = form.querySelector('select[name="feedback_rating"]');
      if (product) product.required = isFeedback;
      if (rating) rating.required = isFeedback;
      var story = form.querySelector('textarea[name="story_body"]');
      if (story) {
        story.minLength = isFeedback ? 10 : 20;
        story.placeholder = isFeedback
          ? 'Tell us how the plant arrived, how it is growing, and what another customer should know.'
          : '';
      }
    }
    function setOrderStatus(text, isErr) {
      var el = qs('[data-community-orders-status]', form);
      if (!el) return;
      el.hidden = !text;
      el.textContent = text || '';
      el.className = 'community-feedback-order__status' + (isErr ? ' community-msg--err' : '');
    }
    function resetOrderItems() {
      var itemSelect = qs('[data-community-order-item-select]', form);
      if (itemSelect) {
        itemSelect.innerHTML = '<option value="">Choose a plant</option>';
      }
    }
    function fillOrderItems(orderId) {
      var order = orderCache.filter(function (o) {
        return String(o.id) === String(orderId);
      })[0];
      var itemSelect = qs('[data-community-order-item-select]', form);
      var orderName = qs('[data-community-order-name]', form);
      if (orderName) orderName.value = order ? (order.name || '') : '';
      resetOrderItems();
      if (!order || !itemSelect) return;
      (order.items || []).forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = JSON.stringify({
          title: item.title || '',
          variant_title: item.variant_title || '',
          product_id: item.product_id || '',
        });
        opt.textContent =
          (item.title || 'Plant') +
          (item.variant_title ? ' · ' + item.variant_title : '') +
          (item.quantity ? ' × ' + item.quantity : '');
        itemSelect.appendChild(opt);
      });
    }
    function applySelectedOrderItem() {
      var itemSelect = qs('[data-community-order-item-select]', form);
      if (!itemSelect || !itemSelect.value) return;
      try {
        var item = JSON.parse(itemSelect.value);
        var product = form.querySelector('input[name="feedback_product_name"]');
        if (product) {
          product.value =
            (item.title || '') + (item.variant_title ? ' · ' + item.variant_title : '');
        }
      } catch (e) {
        /* keep manual field untouched */
      }
    }
    function loadOrders() {
      var btn = qs('[data-community-load-orders]', form);
      if (btn) btn.disabled = true;
      setOrderStatus('Loading your recent orders…', false);
      fetch(proxyAppBase() + '/customer-orders.json', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r.json().then(
            function (j) {
              return { ok: r.ok, status: r.status, body: j };
            },
            function () {
              return { ok: r.ok, status: r.status, body: {} };
            }
          );
        })
        .then(function (res) {
          if (!res.ok || !res.body || !res.body.ok) {
            var detail = (res.body && res.body.detail) || 'Could not load orders. You can still type the plant name below.';
            setOrderStatus(detail, true);
            return;
          }
          orderCache = res.body.orders || [];
          var sel = qs('[data-community-order-select]', form);
          if (sel) {
            sel.innerHTML = '<option value="">Choose an order</option>';
            orderCache.forEach(function (order) {
              var opt = document.createElement('option');
              opt.value = order.id;
              opt.textContent =
                (order.name || order.id) +
                (order.created_at ? ' · ' + String(order.created_at).slice(0, 10) : '');
              sel.appendChild(opt);
            });
          }
          resetOrderItems();
          setOrderStatus(
            orderCache.length
              ? 'Choose an order, then choose the plant you want to review.'
              : 'No recent plant orders found. You can still type the plant name below.',
            !orderCache.length
          );
        })
        .catch(function () {
          setOrderStatus('Could not load orders. You can still type the plant name below.', true);
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    }
    qsa('[data-community-type-toggle]', form).forEach(function (el) {
      el.addEventListener('change', syncFeedbackFields);
    });
    var loadBtn = qs('[data-community-load-orders]', form);
    if (loadBtn) {
      loadBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        loadOrders();
      });
    }
    var orderSelect = qs('[data-community-order-select]', form);
    if (orderSelect) {
      orderSelect.addEventListener('change', function () {
        fillOrderItems(orderSelect.value);
      });
    }
    var itemSelect = qs('[data-community-order-item-select]', form);
    if (itemSelect) {
      itemSelect.addEventListener('change', applySelectedOrderItem);
    }
    syncFeedbackFields();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = qs('[data-community-form-msg]');
      if (msg) {
        msg.textContent = '';
        msg.className = 'community-msg';
        msg.hidden = true;
      }
      var storyInput = form.querySelector('textarea[name="story_body"]');
      var storyText = storyInput ? (storyInput.value || '').trim() : '';
      var isFeedback = selectedType() === 'plant_feedback';
      if (storyText.length > 20000) {
        if (msg) {
          msg.hidden = false;
          msg.className = 'community-msg community-msg--err';
          msg.textContent = (isFeedback ? 'Your feedback' : 'Your story') + ' is too long. Please keep it under 20,000 characters.';
        }
        if (storyInput) storyInput.focus();
        return;
      }
      if (
        !isFeedback &&
        storyText.length > 120 &&
        /[A-Za-z0-9]$/.test(storyText) &&
        !window.confirm(
          'Your story appears to end mid-sentence. Please review the end of the story before submitting. Submit anyway?'
        )
      ) {
        if (storyInput) storyInput.focus();
        return;
      }
      var fd = new FormData(form);
      var url = proxyAppBase() + '/submit.json';
      fetch(url, {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      })
        .then(function (r) {
          return r.json().then(
            function (j) {
              return { ok: r.ok, status: r.status, body: j };
            },
            function () {
              return { ok: r.ok, status: r.status, body: {} };
            }
          );
        })
        .then(function (res) {
          if (msg) {
            msg.hidden = false;
            if (res.ok && res.body && res.body.ok) {
              msg.className = 'community-msg community-msg--ok';
              msg.textContent =
                (res.body && res.body.message) ||
                cfg.copyThanks ||
                'Thank you — your story is under review.';
              form.reset();
              syncFeedbackFields();
            } else {
              msg.className = 'community-msg community-msg--err';
              var d = res.body && res.body.detail;
              var text = '';
              if (typeof d === 'string') {
                text = d;
              } else if (Array.isArray(d)) {
                var required = [];
                var labels = {
                  title: 'title',
                  customer_display_name: 'display name',
                  story_body: 'story',
                  feedback_product_name: 'plant purchased',
                  feedback_rating: 'rating',
                  primary_image: 'image',
                  consent: 'consent',
                };
                var otherMsgs = [];
                d.forEach(function (x) {
                  var msg = (x && x.msg) || '';
                  var loc = Array.isArray(x && x.loc) ? x.loc : [];
                  var field = loc.length ? String(loc[loc.length - 1] || '') : '';
                  if (msg === 'Field required' && field) {
                    var label = labels[field] || field;
                    if (required.indexOf(label) === -1) required.push(label);
                    return;
                  }
                  if (msg) otherMsgs.push(msg);
                });
                if (required.length) {
                  text = 'Please complete required fields: ' + required.join(', ') + '.';
                } else {
                  text = otherMsgs.join(' ');
                }
              }
              if (!text && !res.ok && res.status) {
                if (res.status === 404) {
                  text =
                    cfg.copyProxySubmit ||
                    'Story submissions are not available until the Shopify app proxy is configured for this store (Develop apps → your app → App proxy). The story feed may still work.';
                } else {
                  text =
                    'We could not reach the community service (HTTP ' +
                    res.status +
                    '). If this keeps happening, the app proxy or server may need attention.';
                }
              }
              msg.textContent =
                text || cfg.copySubmitErr || 'Something went wrong. Please try again.';
            }
          }
        })
        .catch(function () {
          if (msg) {
            msg.hidden = false;
            msg.className = 'community-msg community-msg--err';
            msg.textContent = cfg.copySubmitErr || 'Network error. Try again.';
          }
        });
    });
  }

  function bindCommentForm() {
    var form = qs('[data-community-comment-form]');
    if (!form || !cfg.commentsEnabled) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!cfg.loggedIn) return;
      var fd = new FormData(form);
      var slug = form.getAttribute('data-post-slug');
      if (slug) fd.set('post_slug', slug);
      fetch(proxyAppBase() + '/comments.json', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (j) {
          var m = qs('[data-community-comment-msg]', form.parentNode);
          if (m) {
            m.textContent = j.message || '';
            m.hidden = false;
          }
          form.reset();
        });
    });
  }

  function init() {
    bindFilters();
    bindLoadMore();
    bindForm();
    bindCommentForm();
    var modal = qs('[data-community-modal]');
    if (modal) modal.hidden = true;
    loadPosts(true);

    var storySlug = '';
    try {
      storySlug = (new URLSearchParams(window.location.search)).get('story') || '';
    } catch (e) {
      storySlug = '';
    }
    if (storySlug && !isBlockedStorySlug(storySlug)) {
      setTimeout(function () {
        openModal(storySlug);
      }, 150);
    }

    /* Smooth scroll for hero CTAs */
    qsa('[data-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-scroll-to');
        var t = id && document.getElementById(id.replace('#', ''));
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
